export * from './interfaces';
export * from './enums';

export type IAvailability = any; // TODO sychdo: create proper availability interface

export enum RateEnteredAsEnum {
  per_sf = 'per_sf',
  per_month = 'per_month'
}

export enum RateEnteredAsLabelEnum {
  per_sf = 'SF',
  per_month = 'Month'
}

export enum AvailabilitySaleSizeTypeEnum {
  available_space = 'available_space',
  rentable_building_area = 'rentable_building_area',
  building_size = 'building_size',
  acres = 'acres',
}
